import instanceQuery from '../../queries/salesLedger/SalesReceiptTransactionQuery.graphql';
import fragment from '../../fragments/nominal/PostedTransactionsFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const SalesReceiptTransactions: EntityType = {
  type: 'PostedTransactionsResponse',
  formTitle: 'Posted Transactions',
  instance: instanceQuery,
  fragment,
};

export default SalesReceiptTransactions;
